import React from 'react';
import Sidebar from './Sidebar';
import Header from './Header';
import Footer from './Footer';
import ErrorBoundary from './ErrorBoundary';

/**
 * Shared app shell used by authenticated pages.
 * Composition: fixed Sidebar (left) + Header (top) + scrolling main content + Footer (bottom).
 *
 * Pages wrapped with <Layout> should NOT render their own Sidebar.
 */
interface LayoutProps {
  children: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  const userStr = localStorage.getItem('user');
  const user = userStr ? JSON.parse(userStr) : null;
  const userRole = user?.role || '';

  return (
    <div
      style={{
        display: 'flex',
        minHeight: '100vh',
        fontFamily: "'Poppins', sans-serif",
        background: 'var(--color-background-secondary, var(--color-gray-50))',
      }}
    >
      <Sidebar userRole={userRole} />
      <div
        style={{
          flex: 1,
          marginLeft: '225px',
          display: 'flex',
          flexDirection: 'column',
          minHeight: '100vh',
          minWidth: 0,
        }}
      >
        <Header user={user} />
        <main style={{ flex: 1, minWidth: 0 }}><ErrorBoundary>{children}</ErrorBoundary></main>
        <Footer />
      </div>
    </div>
  );
};

export default Layout;
